import React, { useRef, useState, useEffect } from 'react';
import ScoreCard from '@/components/scoreboard/ScoreCard';

export interface ScoreCardData {
  team1: string | undefined;
  team2: string | undefined;
  team1FirstHalfScore: number | undefined;
  team2FirstHalfScore: number | undefined;
  team1SecondHalfScore: number | undefined;
  team2SecondHalfScore: number | undefined;
  team1ExtraFirstHalfScore: number | undefined;
  team2ExtraFirstHalfScore: number | undefined;
  team1ExtraSecondHalfScore: number | undefined;
  team2ExtraSecondHalfScore: number | undefined;
  team1PKScore: number | undefined;
  team2PKScore: number | undefined;
}

interface ScoreSliderProps {
  isEdit: boolean;
  propsScores: ScoreCardData[];
  onInputTeam1?: (index: number) => (value: string) => void;
  onInputTeam2?: (index: number) => (value: string) => void;
  onChangeTeam1FirstHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam2FirstHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam1SecondHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam2SecondHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam1ExtraFirstHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam2ExtraFirstHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam1ExtraSecondHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam2ExtraSecondHalfScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam1PKScore?: (index: number) => (value: number | undefined) => void;
  onChangeTeam2PKScore?: (index: number) => (value: number | undefined) => void;
  onAddScore?: () => void;
  onRemoveScore?: (index: number) => void;
}

const ScoreCardSlider: React.FC<ScoreSliderProps> = ({
  isEdit,
  propsScores,
  onInputTeam1,
  onInputTeam2,
  onChangeTeam1FirstHalfScore,
  onChangeTeam2FirstHalfScore,
  onChangeTeam1SecondHalfScore,
  onChangeTeam2SecondHalfScore,
  onChangeTeam1ExtraFirstHalfScore,
  onChangeTeam2ExtraFirstHalfScore,
  onChangeTeam1ExtraSecondHalfScore,
  onChangeTeam2ExtraSecondHalfScore,
  onChangeTeam1PKScore,
  onChangeTeam2PKScore,
  onAddScore,
  onRemoveScore
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const [scores, setScores] = useState<ScoreCardData[]>([]);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const [showRightButton, setShowRightButton] = useState(true);
  // const [isDragging, setIsDragging] = useState(false);
  // const [startX, setStartX] = useState(0);
  // const [scrollLeft, setScrollLeft] = useState(0);

  const handleInputTeam1 = (index: number) => (value: string) => {
    onInputTeam1 && onInputTeam1(index)(value);
  };

  const handleInputTeam2 = (index: number) => (value: string) => {
    onInputTeam2 && onInputTeam2(index)(value);
  };

  const handleChangeTeam1FirstHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam1FirstHalfScore && onChangeTeam1FirstHalfScore(index)(value);
  };

  const handleChangeTeam2FirstHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam2FirstHalfScore && onChangeTeam2FirstHalfScore(index)(value);
  };

  const handleChangeTeam1SecondHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam1SecondHalfScore && onChangeTeam1SecondHalfScore(index)(value);
  };

  const handleChangeTeam2SecondHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam2SecondHalfScore && onChangeTeam2SecondHalfScore(index)(value);
  };

  const handleChangeTeam1ExtraFirstHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam1ExtraFirstHalfScore && onChangeTeam1ExtraFirstHalfScore(index)(value);
  };

  const handleChangeTeam2ExtraFirstHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam2ExtraFirstHalfScore && onChangeTeam2ExtraFirstHalfScore(index)(value);
  };

  const handleChangeTeam1ExtraSecondHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam1ExtraSecondHalfScore && onChangeTeam1ExtraSecondHalfScore(index)(value);
  };

  const handleChangeTeam2ExtraSecondHalfScore = (index: number) => (value: number | undefined) => {
    onChangeTeam2ExtraSecondHalfScore && onChangeTeam2ExtraSecondHalfScore(index)(value);
  };

  const handleChangeTeam1PKScore = (index: number) => (value: number | undefined) => {
    onChangeTeam1PKScore && onChangeTeam1PKScore(index)(value);
  };

  const handleChangeTeam2PKScore = (index: number) => (value: number | undefined) => {
    onChangeTeam2PKScore && onChangeTeam2PKScore(index)(value);
  };

  const handleAddScore = () => {
    if (scores.length >= 5) return;
    onAddScore && onAddScore();
  };

  const handleRemoveScore = (index: number) => {
    onRemoveScore && onRemoveScore(index);
  };

  const updateNavigationButtons = () => {
    if (!sliderRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
    setShowLeftButton(scrollLeft > 0);
    setShowRightButton(scrollLeft < scrollWidth - clientWidth - 10);
  };

  useEffect(() => {
    setScores(propsScores);

    const slider = sliderRef.current;
    if (!slider) return;

    const handleScroll = () => {
      updateNavigationButtons();
    };

    slider.addEventListener('scroll', handleScroll);
    updateNavigationButtons();

    return () => {
      slider.removeEventListener('scroll', handleScroll);
    };
  }, [propsScores]);

  // const handleMouseDown = (e: React.MouseEvent) => {
  //   setIsDragging(true);
  //   setStartX(e.pageX - sliderRef.current!.offsetLeft);
  //   setScrollLeft(sliderRef.current!.scrollLeft);
  // };

  // const handleTouchStart = (e: React.TouchEvent) => {
  //   setIsDragging(true);
  //   setStartX(e.touches?.[0]?.pageX ?? 0 - sliderRef.current!.offsetLeft);
  //   setScrollLeft(sliderRef.current!.scrollLeft);
  // };

  // const handleMouseMove = (e: React.MouseEvent) => {
  //   if (!isDragging) return;
  //   e.preventDefault();
  //   const x = e.pageX - sliderRef.current!.offsetLeft;
  //   const distance = (x - startX) * 1.5;
  //   sliderRef.current!.scrollLeft = scrollLeft - distance;
  // };

  // const handleTouchMove = (e: React.TouchEvent) => {
  //   if (!isDragging) return;
  //   const x = e.touches?.[0]?.pageX ?? 0 - sliderRef.current!.offsetLeft;
  //   const distance = (x - startX) * 1.5;
  //   sliderRef.current!.scrollLeft = scrollLeft - distance;
  // };

  // const handleDragEnd = () => {
  //   setIsDragging(false);
  //   if (!sliderRef.current) return;

  //   const cardWidth = 272; // カードの幅 + マージン
  //   const currentScroll = sliderRef.current.scrollLeft;
  //   const targetScroll = Math.round(currentScroll / cardWidth) * cardWidth;

  //   sliderRef.current.scrollTo({
  //     left: targetScroll,
  //     behavior: 'smooth'
  //   });
  // };

  const scrollToDirection = (direction: 'left' | 'right') => {
    if (!sliderRef.current) return;
    const cardWidth = 272; // カードの幅 + マージン
    const currentScroll = sliderRef.current.scrollLeft;
    const targetScroll = direction === 'left' ? currentScroll - cardWidth : currentScroll + cardWidth;

    sliderRef.current.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <style>
        {`
          @keyframes buttonFadeIn {
            from {
              opacity: 0;
              transform: translate(0, -50%) scale(0.9);
            }
            to {
              opacity: 1;
              transform: translate(0, -50%) scale(1);
            }
          }

          .nav-button {
            animation: buttonFadeIn 0.2s ease-out forwards;
          }

          .slider-container {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          .slider-container::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
      <div className="relative w-full max-w-full">
        {showLeftButton && (
          <button
            type="button"
            onClick={() => scrollToDirection('left')}
            className="nav-button absolute -left-2 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-40 rounded-full p-2 shadow hover:bg-white hover:bg-opacity-100">
            <svg
              className="w-6 h-6 text-gray-400 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m15 19-7-7 7-7"
              />
            </svg>
          </button>
        )}

        <div
          ref={sliderRef}
          className="slider-container flex items-stretch overflow-x-auto scroll-smooth"
          style={{
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch'
          }}
          // onMouseDown={handleMouseDown}
          // onMouseMove={handleMouseMove}
          // onMouseUp={handleDragEnd}
          // onMouseLeave={handleDragEnd}
          // onTouchStart={handleTouchStart}
          // onTouchMove={handleTouchMove}
          // onTouchEnd={handleDragEnd}
        >
          {scores.map((score, index) => (
            <div key={index} className="relative flex-none mr-4 pb-1 snap-start" style={{ scrollSnapAlign: 'start' }}>
              <ScoreCard
                isEdit={isEdit}
                propsTeam1={score.team1}
                propsTeam2={score.team2}
                propsTeam1FirstHalfScore={score.team1FirstHalfScore}
                propsTeam2FirstHalfScore={score.team2FirstHalfScore}
                propsTeam1SecondHalfScore={score.team1SecondHalfScore}
                propsTeam2SecondHalfScore={score.team2SecondHalfScore}
                propsTeam1ExtraFirstHalfScore={score.team1ExtraFirstHalfScore}
                propsTeam2ExtraFirstHalfScore={score.team2ExtraFirstHalfScore}
                propsTeam1ExtraSecondHalfScore={score.team1ExtraSecondHalfScore}
                propsTeam2ExtraSecondHalfScore={score.team2ExtraSecondHalfScore}
                propsTeam1PKScore={score.team1PKScore}
                propsTeam2PKScore={score.team2PKScore}
                onInputTeam1={handleInputTeam1(index)}
                onInputTeam2={handleInputTeam2(index)}
                onChangeTeam1FirstHalfScore={handleChangeTeam1FirstHalfScore(index)}
                onChangeTeam2FirstHalfScore={handleChangeTeam2FirstHalfScore(index)}
                onChangeTeam1SecondHalfScore={handleChangeTeam1SecondHalfScore(index)}
                onChangeTeam2SecondHalfScore={handleChangeTeam2SecondHalfScore(index)}
                onChangeTeam1ExFirstScore={handleChangeTeam1ExtraFirstHalfScore(index)}
                onChangeTeam2ExFirstScore={handleChangeTeam2ExtraFirstHalfScore(index)}
                onChangeTeam1ExSecondScore={handleChangeTeam1ExtraSecondHalfScore(index)}
                onChangeTeam2ExSecondScore={handleChangeTeam2ExtraSecondHalfScore(index)}
                onChangeTeam1PKScore={handleChangeTeam1PKScore(index)}
                onChangeTeam2PKScore={handleChangeTeam2PKScore(index)}
              />
              {isEdit && (
                <button
                  type="button"
                  onClick={() => handleRemoveScore(index)}
                  className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full text-white bg-gray-300 bg-opacity-60 hover:bg-gray-300 hover:bg-opacity-100 text-sm dark:hover:bg-gray-600 dark:hover:text-white">
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close menu</span>
                </button>
              )}
            </div>
          ))}
          {isEdit && (
            <div className="flex-none snap-start">
              <button
                type="button"
                onClick={handleAddScore}
                className="flex items-center justify-center bg-white border border-gray-300 rounded-lg p-4 w-60 h-32 hover:bg-gray-50 transition-colors">
                <span className="font-footballlog text-gray-500 text-sm">+ Add</span>
                <span className="ms-2 font-footballlog text-gray-500 text-sm">
                  (<span className="font-bold">{scores.length}</span>/5)
                </span>
              </button>
            </div>
          )}
        </div>

        {showRightButton && (
          <button
            type="button"
            onClick={() => scrollToDirection('right')}
            className="nav-button absolute -right-2 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-40 rounded-full p-2 shadow hover:bg-white hover:bg-opacity-100">
            <svg
              className="w-6 h-6 text-gray-400 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 5 7 7-7 7"
              />
            </svg>
          </button>
        )}
      </div>
    </>
  );
};

export default ScoreCardSlider;
